module.exports = __webpack_public_path__ + "static/media/Chamli.1849a014.jpg";